import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { Box, IconButton, InputAdornment, TextField } from "../../components";
import { SEARCH_DELAY } from "../../consts";

export const SearchBar = (props: {
  onStoppedTyping: (searchString: string) => void;
  setSearchFocused?: (value: boolean) => void;
  typeDelay?: boolean;
  size?: "small" | "medium" | undefined;
}) => {
  const typeDelay = props.typeDelay ?? true;
  const INITIAL_WIDTH: string = "300px";
  const EXPANDED_WIDTH: string = "300px";

  const [searchString, setSearchString] = useState<string>("");
  const [typeDelayTimeoutId, setTypeDelayTimeoutId] = useState<any>();
  const [focused, setFocused] = useState<boolean>(false);
  const [show, setShow] = useState(false);

  function handleChange(e: any) {
    setSearchString(e.target.value);

    clearTimeout(typeDelayTimeoutId);
    const _typeDelayTimeoutId = setTimeout(() => {
      props.onStoppedTyping(e.target.value);
    }, typeDelay ? SEARCH_DELAY : 0);
    setTypeDelayTimeoutId(_typeDelayTimeoutId);
  }

  function keyPress(e: any) {
    if (e.keyCode === 13) {
      props.onStoppedTyping(e.target.value);
      setTypeDelayTimeoutId(typeDelayTimeoutId);
    }
  }

  const handleClear = () => {
    setSearchString("");
    props.onStoppedTyping("");
  };

  return (
    <>
      {!show && (
        <Box>
          <IconButton onClick={() => setShow(true)}>
            <SearchIcon />
          </IconButton>
        </Box>
      )}

      {show && (
        <TextField
          autoFocus
          value={searchString}
          sx={{
            width: focused ? EXPANDED_WIDTH : INITIAL_WIDTH,
            transition: "width 300ms",
          }}
          onFocus={() => {
            setFocused(true);
            props.setSearchFocused?.(true);
          }}
          onBlur={() => {
            setFocused(false);
            if (!searchString) setShow(false);
            props.setSearchFocused?.(false);
          }}
          onChange={handleChange}
          onKeyDown={keyPress}
          placeholder="Search"
          autoComplete="off"
          size={props.size ?? "medium"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ opacity: 0.6 }} />
              </InputAdornment>
            ),
            endAdornment: searchString ? (
              <InputAdornment position="end">
                <IconButton size="small" onClick={handleClear}>
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
        />
      )}
    </>
  );
};
